import Vue from 'vue';
import { VueConstructor, } from 'vue/types/umd';
import App from './index.vue';
import { Store, } from './store';

Vue.config.productionTip = false;

interface InvestmentAreaOptions {
	googleMapsApiKey: string;
}

export function ContentMap(layout: VueConstructor<Vue>, props: InvestmentAreaOptions, investmentAreaContent: typeof import('./content-map-data.json'), elementToMount: string) {
	const store = Store(investmentAreaContent).original;
	new Vue({
		render: (h) => h(layout, [h(App, {
			props,
		}),]),
		store,
	}).$mount(elementToMount);
}
